import { BoardMessage } from '../models/board.model';

export const TILE_COLORS = ['#14140f', '#f4661e', '#ffd23f', '#7aa662', '#c94e0f', '#efe9dc'];

/** Old editors stored a flattened fixed-width grid. Convert once, without losing overflow. */
export function normalizeMessage(message: BoardMessage, columns: number): BoardMessage {
  if (message.layout === 'lines') return message;
  const text = message.text.includes('\n')
    ? message.text
    : (message.text.match(new RegExp(`.{1,${columns}}`, 'gu')) || [''])
        .map((line) => line.trimEnd())
        .join('\n');
  return { ...message, text, align: message.align || 'left', layout: 'lines' };
}

export function overflows(text: string, rows: number, columns: number): boolean {
  const lines = text.toUpperCase().split('\n');
  return lines.some(
    (line, index) => Array.from(line).length > columns || (index >= rows && line.length > 0),
  );
}

export function messageGrid(
  message: BoardMessage | undefined,
  rows: number,
  columns: number,
): string[] {
  const lines = message?.text.toUpperCase().split('\n') || [];
  return Array.from({ length: rows }, (_, row) => {
    const chars = Array.from(lines[row] || '').slice(0, columns);
    const remaining = columns - chars.length;
    const left =
      message?.align === 'right'
        ? remaining
        : message?.align === 'center'
          ? Math.floor(remaining / 2)
          : 0;
    return [...Array(left).fill(' '), ...chars, ...Array(remaining - left).fill(' ')];
  }).flat();
}

export function accentInk(color: string): string {
  return color === '#ffd23f' || color === '#efe9dc' ? '#14140f' : '#fff';
}
